import '../../index.css';
var styles = {
  "buttonWrapper": "bp_select_menu_grid_option_module_buttonWrapper--11117",
  "withLabel": "bp_select_menu_grid_option_module_withLabel--11117",
  "withLabel--default": "bp_select_menu_grid_option_module_withLabel--default--11117",
  "square": "bp_select_menu_grid_option_module_square--11117",
  "outlineHost": "bp_select_menu_grid_option_module_outlineHost--11117",
  "circle": "bp_select_menu_grid_option_module_circle--11117",
  "loading": "bp_select_menu_grid_option_module_loading--11117",
  "color": "bp_select_menu_grid_option_module_color--11117",
  "strikeThrough": "bp_select_menu_grid_option_module_strikeThrough--11117",
  "optionButton": "bp_select_menu_grid_option_module_optionButton--11117",
  "labeled": "bp_select_menu_grid_option_module_labeled--11117",
  "text": "bp_select_menu_grid_option_module_text--11117",
  "text--large": "bp_select_menu_grid_option_module_text--large--11117",
  "text--default": "bp_select_menu_grid_option_module_text--default--11117",
  "iconContainer": "bp_select_menu_grid_option_module_iconContainer--11117",
  "iconContainer--size-default": "bp_select_menu_grid_option_module_iconContainer--size-default--11117",
  "iconContainer--size-large": "bp_select_menu_grid_option_module_iconContainer--size-large--11117",
  "iconContainer--default": "bp_select_menu_grid_option_module_iconContainer--default--11117",
  "iconContainer--box": "bp_select_menu_grid_option_module_iconContainer--box--11117",
  "iconContainer--docgen": "bp_select_menu_grid_option_module_iconContainer--docgen--11117",
  "iconContainer--forms": "bp_select_menu_grid_option_module_iconContainer--forms--11117",
  "iconContainer--sign": "bp_select_menu_grid_option_module_iconContainer--sign--11117",
  "active": "bp_select_menu_grid_option_module_active--11117",
  "dragging": "bp_select_menu_grid_option_module_dragging--11117",
  "disabled": "bp_select_menu_grid_option_module_disabled--11117"
};
export { styles as default };